import { useState } from "react";
import CaseSummaryBox from "../CaseSummaryBox";
import PreviousCareRepeater from "./previouscare/PreviousCareRepeater";
import { useSelector } from "react-redux";
import Button from "../../../../common/Button";
import classes from './PreviousCareSection.module.css'
import { objectIsEmpty } from "../../../../../lib/script";


export default function PreviousCareSection({apiCase, permissionType}) {
    const activeCase = useSelector(state => state.case.activeCase)

    const [showPreviousCare, setShowPreviousCare] = useState(false)

    let hasPreviousCare = false
    // && activeCase.additional.prev_care_list_legacy
    if (activeCase && activeCase.additional && activeCase.additional.prev_care_list && activeCase.additional.prev_care_list.length > 0 && activeCase.additional.prev_care_list.some(item => !objectIsEmpty(item.data)) ) {
        hasPreviousCare = true
    }

    function addPreviousCareHandler() {
        setShowPreviousCare(prev => !prev)
    }

    return <CaseSummaryBox title={'Previous Care'}>
        {activeCase.additional?.prev_care_list_legacy && <span className={classes.legacy}>
                <span className={classes.legacy_label}>ECM 1 Previous Care</span>
                <span className={classes.legacy_value}>{activeCase.additional.prev_care_list_legacy}</span> <br/> <br/>
            </span>}
        <PreviousCareRepeater apiCase={apiCase} permissionType={permissionType}/>
    </CaseSummaryBox>
}